import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_ADD_FOLDER } from '../../constants/analytics';
import {
  CreateFolderBody,
  CreateFolderContract,
} from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_FOLDERS } from '../../constants/endpoints';
import request, { getData } from './request';
import toFolder from './toFolder';

const createFolder = async (
  classRoomId: string,
  folder: CreateFolderBody,
  localId?: string,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled: boolean = false
) => {
  const url = CLASSROOM_MATERIAL_FOLDERS(classRoomId, educatorOnly);
  const data = await request<CreateFolderContract>({
    method: 'post',
    url,
    data: { folder, localId },
    headers: { 'x-correlation-id': correlationId },
  }).then(getData);
  try {
    analyticsTrackEvent(MATERIALS_ADD_FOLDER, {
      itemId: data.id,
      spaceId: classRoomId,
      scheduledFor: folder.scheduledFor,
      itemType: 'Material',
      isRbacEnabled,
    });
  } catch {
    // Analytics must not turn a successful API request into a failed action.
  }
  return toFolder(data);
};

export type CreateFolder = typeof createFolder;

export default createFolder;
